function toggleNeedsItem(id) {
  const parent = document.querySelector(`#${id}`);

  const buttonOpenedModificatorClassName = "needs__item__button__wrapper_opened";
  const bodyOpenedModificatorClassName = "needs__item__body_opened";

  const currButton = parent.querySelector(".needs__item__button");
  const currBody = parent.querySelector(".needs__item__body");
  const currContent = parent.querySelector(`.needs__item__content`);

  if (currButton.classList.contains(buttonOpenedModificatorClassName)) {
    currButton.classList.remove(buttonOpenedModificatorClassName);
  } else {
    currButton.classList.add(buttonOpenedModificatorClassName);
  }

  if (currBody.classList.contains(bodyOpenedModificatorClassName)) {
    currBody.classList.remove(bodyOpenedModificatorClassName);
    currBody.style.height = 0 + "px";
  } else {
    currBody.classList.add(bodyOpenedModificatorClassName);
    currBody.style.height = currContent.scrollHeight + "px";
  }
}

window.toggleNeedsItem = toggleNeedsItem;
